import Vue from 'vue';

/* Setup axios */
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
Vue.prototype.$http = axios;

import app from './app';

if(window.__INITIAL_STATE__) {
    app.$store.replaceState(window.__INITIAL_STATE__);
}

app.$store.state.webp = window.webp;

app.$mount('#app');

app.$store.state.screenWidth = window.innerWidth;
app.$store.state.updateBodyHeight();
app.$store.state.updateScroll();
window.addEventListener('resize', function (event) {
    app.$store.state.screenWidth = window.innerWidth;
    app.$store.state.updateBodyHeight();
});
window.addEventListener('scroll', function (event) {
    app.$store.state.updateScroll();
});